import { FE_ENABLE_MESSENGER_INLINE_CONTEXT_250610 } from "@faire/messenger-settings/FE_ENABLE_MESSENGER_INLINE_CONTEXT_250610";
import { useSetting } from "@faire/messenger/settings/__internal__/useSetting";

export const useSettingEnableMessengerInlineContext = () =>
  useSetting(FE_ENABLE_MESSENGER_INLINE_CONTEXT_250610);
